import React from 'react'
import { Omny, Props } from 'component-library/publication/Embed/web/Omny'
import { createRegisterableComponent } from 'common/routing/page-definition'

export interface OmnyRouteProps extends Props {}

export const OmnyRegistration = createRegisterableComponent('omny-web', (props: OmnyRouteProps) => {
    return (
        <Omny
            height={props.height}
            link={props.link}
            width={props.width}
            verticalSpacing={props.verticalSpacing}
        />
    )
})
